import { useQuery } from '@apollo/client';
import { StoresDocument } from '../../graphql/generated/graphql';

interface UseStoresProps {
  pagination?: {
    limit: number;
    offset: number;
  };
}

export const useStores = (
  { pagination }: UseStoresProps = {},
  options?: { includeUsersData?: boolean; includeAttentionNeeded?: boolean },
) => {
  const { limit = 100, offset = 0 } = pagination || {};

  const { data, loading } = useQuery(StoresDocument, {
    variables: {
      pagination: {
        limit,
        offset,
      },
      ...options,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    stores: data?.stores?.records || [],
    loading,
  };
};
